import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import i18n from 'i18next';
export const dmApi = createApi({
    reducerPath: "dmApi",
    baseQuery: async (args, api, extraOptions) => {
        const rawBaseQuery = fetchBaseQuery({
            baseUrl: process.env.REACT_APP_BASE_URL,
            prepareHeaders: (headers, { getState }) => {
                headers.set('X-Locale', i18n.language); // Add locale header
                
                // Use user's timezone if logged in, otherwise use browser timezone
                let timezone;
                const state = getState();
                const userTimezone = state?.global?.userTimezone;
                
                if (userTimezone && userTimezone !== "Etc/Greenwich") {
                    // Use the user's saved timezone from profile
                    timezone = userTimezone;
                } else {
                    // Try to get from localStorage as fallback
                    const storedTimezone = localStorage.getItem("userTimezone");
                    if (storedTimezone && storedTimezone !== "Etc/Greenwich") {
                        timezone = storedTimezone;
                    } else {
                        // Get browser timezone
                        const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                        
                        // If browser returns unreliable timezone, try localStorage as last resort
                        if (browserTimezone === "Etc/Greenwich" || browserTimezone === "UTC") {
                            timezone = storedTimezone || "UTC";
                        } else {
                            timezone = browserTimezone;
                        }
                    }
                }
                
                headers.set('X-Timezone', timezone);

                return headers;
            },
        });
        const result = await rawBaseQuery(args, api, extraOptions);
        if (result.error && result.error.status === 401) {

            window.location.href = "/login"; // Navigate to login
        }

        // if (result.error && result.error.status === 429) {

        // }
        return result;
    },
    tagTypes: [
        "suppliers",
        "getAllRoles",
        "barChart",
        "ripeningRoomById",
        "getAllRoles",
        "getAllSummary",
        "employeeReceiving",
        "managers",
        "managerById",
        "supplierById",
        "pieChart",
        "ovenData",
        "reworkOvenData",
        "cartList",
        "ovenList",
        "itemsList",
        "processingEmployee",
        "summaryProcessing",
        "morningShift",
        "eveningShift",
        "morningEmployee",
        "eveningEmployee",
        "rawMaterials",
        "summary",
        "rejectedLog",
        "suppliersList",
        "fruitList",
        "rawMaterialsById",
        "recordColdStorage",
        "recordColdStorageById",
        "ripeningBarChart",
        "ripeningPieChart",
        "sortingPieChart",
        "washingSummary",
        "ripeningSummary",
        "ripeningRooms",
        "ripeningRoomById",
        "roomCaseById",
        "sortingRecord",
        "sortingSummary",
        "employees",
        "workingAreas",
        "staffAttendance",
        "staffAttendanceSummary",
        "staffAttendanceReport",
        "employeeAttendance",
        "employeeAttendanceSummary",
        "employeeAttendanceReport",
        "material",
        "materialById",
        "brokerageSummary",
        "brokerageSortAndPackedSummary",
        "packing",
        "boxesPacked",
        "brokerageEmployee",
        "brokerageRefrigeration",
        "brokerageBarChart",
        "brokerageSortingChart",
        "brokeragePackingChart",
        "brokerageMetricsChart"
    ],
    // Global refetch settings - applies to ALL queries
    // refetchOnFocus: true,
    refetchOnReconnect: true,
    refetchOnMountOrArgChange: 30,
    endpoints: () => ({}),
});
